'use strict';

jQuery($ => {
    const speed = 200;
    const button = $('.gecko-banner-desktop__link--search');
    const search = $('.gecko-search-desktop__container');
    const searchInput = search.find('input[type="search"]').focus();

    button.on('mousedown', (e) => {
        e.preventDefault();

        if (search.attr('data-status') === 'active') {
            search.removeAttr('data-status').stop().slideUp(speed);
            button.removeAttr('data-status');
        } else {
            search.attr('data-status', 'active').stop().slideDown(speed);
            searchInput.focus();
            button.attr('data-status', 'active');
        }
    });

    button.on('click', (e) => {
        e.preventDefault();
    });

    searchInput.on('blur', (e) => {
        e.preventDefault();

        if (searchInput.val() === "") {
            search.removeAttr('data-status').stop().slideUp(speed);
            button.removeAttr('data-status');
        }
    });
});
